
export default {
    props: {
        stations:{
            default: []
        }
    },

    methods: {
        getRating(rating) {
            var value = rating.split('(') && rating.split('(').length > 0 ? rating.split('(')[0] : '';
            value = value.replace(/[^\d.-]/g, '');
            return value ? parseInt(value) : ''
        },

        getNumberOfRatings(rating) {
            var value = rating.split('(') && rating.split('(').length > 1 ? rating.split('(')[1] : '';
            value = value.replace(/[^\d.-]/g, '');
            return value ? parseInt(value) : ''
        },

        parseRatingString(rating){
            var value = rating.replace("Ratings", 'Ratings ')
            if(this.getNumberOfRatings(rating) == 1){
                value = value.replace("reviews", 'review')
            }
            return value
        },

        addressSplit(address) {
            var value = address.split(',') && address.split(',').length > 0 ? address.split(',') : [];
            value = value.filter(item => item);
            return value
        },

        stationName(name) {
            name = name.replace(/ /g, '-');
            name = name.replace(/\//g, '-');
            return name ? name : ''
        },

        // To add a fallback placeholder image if not rendereds from API
        setFallbackImageUrl(event) {
            event.target.src = require(`@/assets/img/footer/mot-logo.svg`)
        },

    }
}
